import { YANDEX_METRICS_IDS } from '../consts.js';

/**
 * Parse cookie
 * @param {string} value - cookie string
 * @param {string} separator
 * @returns {Object}
 */
const parseCookie = (value, separator) => {
    if (!value) {
        return {};
    }
    const decodedValue = decodeURIComponent(value);
    return decodedValue.split(separator).reduce((acc, cur) => {
        const [key, value] = cur.split('=');
        acc[key] = /^\s/.test(value) || !value ? undefined : value;
        return acc;
    }, {});
};
const parseUTMCookie = (value) => parseCookie(value, '|');
const parsePartnerCookie = (value) => parseCookie(value, '&');
const parsePromotionCookie = (value) => parseCookie(value, '|');
const minifyString = (string) => string.replace(/(\r\n|\n|\r|\\n)/gm, '').replace(/\s\s+/g, ' ');
const getYandexMetricsId = (isWhiteLabel) => {
    if (isWhiteLabel)
        return YANDEX_METRICS_IDS.WHITELABEL;
    return YANDEX_METRICS_IDS.COMMON;
};
const getGtmOptionsFromSravniTMOptions = (options) => {
    const { googleTmId, userId, theme, abTestingStatistics, ab, wl, isWebview, fullURL, push } = options;
    return {
        id: googleTmId,
        ...(userId ? { userId } : {}),
        ...(theme ? { theme } : {}),
        ...(ab ? { ab } : {}),
        ...(abTestingStatistics ? { abTestingStatistics } : {}),
        ...(wl ? { wl } : {}),
        ...(fullURL ? { fullURL } : {}),
        ...(typeof isWebview === 'boolean' ? { isWebview } : {}),
        ...(push ? { push } : {}),
    };
};
const getYandexMetricsOptionsFromSravniTMOptions = (options) => {
    const { yandexMetricsId: deprecatedMetricsId, wl, webvisor: deprecatedWebvisor, yandexMetricsOptions: { id: metricsId, webvisor: yandexWebvisor, childIframe, defer } = {}, } = options;
    const webvisor = yandexWebvisor || deprecatedWebvisor;
    const yandexMetricsId = metricsId || deprecatedMetricsId;
    const isWhiteLabel = typeof wl !== 'undefined';
    // eslint-disable-next-line no-unneeded-ternary
    const id = yandexMetricsId ? yandexMetricsId : getYandexMetricsId(isWhiteLabel);
    return {
        id,
        ...(typeof webvisor === 'boolean' ? { webvisor } : {}),
        ...(typeof childIframe === 'boolean' ? { childIframe } : {}),
        ...(typeof defer === 'boolean' ? { defer } : {}),
    };
};
const convertOptionsToDefaultValues = (options) => {
    const { userId, theme, isWebview, wl, abTestingStatistics } = options;
    return [
        {
            isWebview: !!isWebview,
        },
        ...(userId ? [{ SravniUserId: userId }] : []),
        ...(theme ? [{ theme }] : []),
        ...(wl ? [{ wlLocation: wl.wlLocation }] : []),
        ...(wl ? [{ partnerLocation: wl.partnerLocation }] : []),
        ...(wl ? [{ fullURL: wl.fullURL }] : []),
        ...(abTestingStatistics ? [{ abTestingStatistics: abTestingStatistics.statistics }] : []),
        ...(abTestingStatistics ? [{ analyticsId: abTestingStatistics.userId }] : []),
    ].filter(Boolean);
};

export { convertOptionsToDefaultValues, getGtmOptionsFromSravniTMOptions, getYandexMetricsId, getYandexMetricsOptionsFromSravniTMOptions, minifyString, parseCookie, parsePartnerCookie, parsePromotionCookie, parseUTMCookie };
//# sourceMappingURL=index.js.map
